import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { userType } from 'src/app/constants/global-constants';
import { IDashboardMidwifePayload } from 'src/app/models/dashboard.models';
import { AuthService } from 'src/app/services/auth.service';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  userType = userType;
  midwifeId: any;
  midwife: IDashboardMidwifePayload;
  loggedIn: boolean;
  loading: boolean;

  constructor(public homeService: HomeService,
    private _Activatedroute : ActivatedRoute,
    public authService: AuthService) { }

  ngOnInit(): void {
    this.loggedIn = this.authService.user?.userType != undefined ? true : false;
    this._Activatedroute.paramMap.subscribe(params => { 
      this.midwifeId = params.get('midwifeId');
      this.loading = true;
      this.getMidwifeProfile(); 
    });
  }

  getMidwifeProfile(){
    this.homeService.getMidwifeProfileDetail(this.midwifeId)
    .subscribe((res)=>{
      this.loading = false;
      this.midwife = res.payload;
      console.log("Midwife Profile:", res);
    },err=>{
      console.error("Midwife Profile Error:", err);
    });
  }
}
